module.exports = __webpack_public_path__ + "img/arrowDown.d610b50e.svg";